import { combineReducers } from "redux";
import mainReducer from "@gc-npm/reducers.main-reducer";
import headerReducer from "@gc-npm/reducers.header-reducer";
import detailedProductReducer from "@/reducers/detailed-product-reducer";
import modalsReducer from "@gc-npm/reducers.modals-reducer";
import getMyProductsReducer from "@/reducers/get-my-products-reducer";
import mobileInsuranceReducer from "@/reducers/mobile-insurance-reducer";
import devicesListReducer from "@/reducers/devices-list";
import pageInfoReducer from '@/reducers/page-info';
import searcherReducer from "@/reducers/searcher";

const REDUCERS_LIST = {
  main: mainReducer,
  header: headerReducer,
  device: detailedProductReducer,
  devicesList: devicesListReducer,
  searcher: searcherReducer,
  modals: modalsReducer,
  getMyProducts: getMyProductsReducer,
  mobileInsuranceReducer,
  pageInfo: pageInfoReducer,
};

const rootReducers = () =>
  combineReducers({
    ...REDUCERS_LIST,
  });

export default rootReducers;
